

const BooleanInput = ({ label, value, name, state, onChange}) => {

    if (state) {
        value = state[name];
    }

    const handleChange = (e) => {
        const newEvent = {
            target: {
                name: e.target.name,
                value: e.target.checked,
            },
        };
        onChange(newEvent);
    }

    return (
        <div className={'form-input-area__input'}>
            <label>
                <input type="checkbox" name={name} checked={value} onChange={handleChange} />
                {label && <span> {label} </span>}
            </label>
        </div>
    )
}

export default BooleanInput;